import React from 'react';
import styled from 'styled-components';
import { Icon } from 'components/shared';
import { Paragraph, Strong, Wrapper, Well } from 'components/shared';

function SimplifiedLoans() {
  return (
    <Wrapper padded>
      <Well title="Real Estate Investor Loans... Simplified">
        <StyledParagraph>
          We have definitely walked a mile in your shoes, fixing and flipping over 300 homes, which has made us into a
          team of dedicated loan professionals with industry experience.
        </StyledParagraph>
        <List>
          <ListLi>
            <div><Icon icon="checkmarkCircle" width="1.5" /></div><Strong>Easy online process with approval and rate quote in minutes.</Strong>
          </ListLi>
          <ListLi>
            <div><Icon icon="checkmarkCircle" width="1.5" /></div><Strong>Personalized service with your own loan consultant and closing agent.</Strong>
          </ListLi>
          <ListLi>
            <div><Icon icon="checkmarkCircle" width="1.5" /></div><Strong>Fast closings in 10-14 days.</Strong>
          </ListLi>
        </List>
      </Well>
    </Wrapper>
  );
}

const StyledParagraph = styled(Paragraph)`
  font-size: var(--font-size-s);
  font-weight: 300;
  color: #1e1e1e;
`;

const List = styled.ol`
  margin: 1em 0;
  list-style-type: none;
`;

const ListLi = styled.li`
  line-height: var(--line-height-list);
  font-size: var(--font-size-s);
  color: var(--color-primary);
  display: flex;
  padding-top: 2em;
  align-items: center;
  & strong {
    margin-left: 1em;
}
`;

export default SimplifiedLoans;
